import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { isEmpty, isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

export default function SimpleDialog({
  open,
  toggleOpen,
  title,
  children,
  cancell,
  submit,
  textCancell,
  textSubmit,
}) {
  return (
    <Dialog open={open} onClose={() => toggleOpen(false)}>
      {!isEmpty(title) && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{children}</DialogContent>
      {(isFunction(cancell) || isFunction(submit)) && (
        <DialogActions>
          {isFunction(submit) && (
            <Button
              startIcon={<Check />}
              color="primary"
              variant="outlined"
              onClick={() => submit()}
            >
              {textSubmit || t('s.geral.botaoconfirmar')}
            </Button>
          )}

          {isFunction(cancell) && (
            <Button
              startIcon={<Close />}
              color="secondary"
              variant="outlined"
              onClick={() => cancell()}
            >
              {textCancell || t('s.geral.botaocancelar')}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
  cancell: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  submit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  textCancell: PropTypes.string,
  textSubmit: PropTypes.string,
};

SimpleDialog.defaultProps = {
  title: '',
  cancell: false,
  submit: false,
  textCancell: '',
  textSubmit: '',
};
